// Refer:https://loading.io/
import React from "react";
import "./loader.css";
import LoaderGif from "./loader.gif";

const TableLoader = ({ colspan }) => {
	return (
		<tbody className="">
			<tr className="">
				<td colSpan={colspan} className="text-center">
					<img src={LoaderGif} alt="loading" style={{ height: "40px" }} />
				</td>
			</tr>
		</tbody>
	);
};

export default TableLoader;
